module.exports = __webpack_public_path__ + "img/logoDarkHor.9b4122f3.svg";